// extracted by mini-css-extract-plugin
export default {"container":"ChargePointConfigList_container__5cDp8","addChargePointButton":"ChargePointConfigList_addChargePointButton__-IeR+"};